import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { RoleGuard } from '../guards/role-guard.service'

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import(
        './components/program-initiation-route-container/program-initiation-route.container'
      ).then((m) => m.ProgramInitiationRouteContainerComponent),
    data: { contextPath: ['program-initiation'] },
    canActivate: [RoleGuard],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProgramInitiationRoutingModule {}
